









import { Component, Mixins } from "vue-property-decorator";
import { ContentMixin } from "./mixins";

@Component
export default class WizardContentNotImplemented extends Mixins(ContentMixin) {
  get errorMessage(): string {
    return "該当するtype(" + this.content.type + ")のcontentは実装されていません。";
  }

  showErrorInfo(): void {
    this.$error("未実装type", this.errorMessage);
  }

  get shouldShow(): boolean {
    return this.$configuration.behavior.wizard.editor.shouldShowNotImplemented;
  }
}
